/** 
*@author: satyamurthy.a
*@Description : 
**/
import { connect } from 'react-redux';
import { Input, Tooltip,Button } from 'antd';
import ListView from '../../../Utils/ListView';
import Highlighter from 'react-highlight-words';
import { encode as base64_encode } from 'base-64';
import { constant } from '../../../Utils/constants';
import React, { useState, useEffect, useRef } from 'react';
import translation from '../../../../../commons/translation';

import { EditOutlined, SearchOutlined } from '@ant-design/icons';
import { API_INSPECTIONCONFIG } from '../../../../../commons/api';
import { getMasterList, deleteMaster } from '../../../Utils/FormCalls';

const urlList = {
  list: API_INSPECTIONCONFIG.GET,
  getbyId: API_INSPECTIONCONFIG.GetId,
  delete: API_INSPECTIONCONFIG.DELETE
};

const QuestionMasters = (props) => {
  const [dataSource, setDataSource] = useState([]);
  // const [form, setForm] = useState({});
  const [searchText, setSearchText] = useState('');
  const searchInput = useRef(null);

  useEffect(() => {
    const fetchData = async () => {
      const data = await getMasterList(urlList.list);
      setDataSource(data);
    };
    fetchData();
  }, []);

  const _editRecord = (record) => {
    props.navigate({ pathname: `/rubus/AMM/InspectionMasterDetails/${base64_encode(record.Id)}` });
  };

  const _deleteById = async (id) => {
    await deleteMaster(urlList.delete, id);
    const data = await getMasterList(urlList.list);
    setDataSource(data);
  };

  const handleSearch = (selectedKeys, confirm) => {
    confirm();
    setSearchText(selectedKeys[0]);
  };

  const getColumnSearchProps = (dataIndex) => ({

    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={searchInput}
          placeholder={translation(props.translationCache, `Search ${dataIndex}`)}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button
          onClick={() => handleSearch(selectedKeys, confirm)}
          style={{ width: 90, marginRight: 8 }}
        >
          {translation(props.translationCache, 'Search')}
        </Button>
        <Button
          danger
          style={{ width: 90 }}
          onClick={() => {
            clearFilters();
            confirm({ closeDropdown: true });
            setSearchText('');
          }}
        >
          {translation(props.translationCache, 'Reset')}
        </Button>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined
        style={{ color: filtered ? '#1890ff' : undefined, }}
      />
    ),
    onFilter: (value, record) =>
      record && record[dataIndex] && record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current.select());
      }
    },
    render: (text) => (
      <Highlighter
        highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
        searchWords={[searchText]}
        autoEscape
        textToHighlight={text && text.toString()}
      />
    )
  });

  const columns = [
    {
      title: translation(props.translationCache, constant.InspectionId),
      dataIndex: 'InspectionId',
      key: 'InspectionId',
      filter: true,
      ...getColumnSearchProps('InspectionId')
    },
    {
      title: translation(props.translationCache, constant.InspectionDesc),
      dataIndex: 'Description',
      key: 'Description',
      filter: true,
      ...getColumnSearchProps('Description')
    },
    {
      title: translation(props.translationCache, constant.action),
      width: '600',
      render: (text, record) => (
        <>
          <Button onClick={() => {
            _editRecord(record);
          }}>
            <Tooltip title={translation(props.translationCache, 'Edit')}>
              <EditOutlined />
            </Tooltip>
          </Button>
        </>
      )
    }
  ];

  return (
    <>
      <ListView
        {...props}
        columns={columns}
        dataSource={dataSource}
        config={{
          title: translation(props.translationCache, 'Inspection'),
          viewTypes: ['add', 'card', 'table'],
          defaultViewType: 'table',
          filterType: 'ByAttributeValue',
          attributeList: ['InspectionId'],
          firstTitle: 'InspectionId',
          secondTitle: 'FirstName',
          thirdTitle: 'CreatedDate',
          actions: ['edit'],
          edit: {
            byAttribute: 'Id',
            redirectURL: '/rubus/AMM/InspectionMasterDetails'
          },
          deletee: {
            byAttribute: 'Id'
          }
        }}
        delete={_deleteById}
      />
    </>
  );
};

const mapStateToProps = (state) => ({
  translationCache: state.TranslationReducer.translationCache,
});

export default connect(mapStateToProps)(QuestionMasters);